import {
  ActionIcon,
  Tooltip,
  useComputedColorScheme,
  useMantineColorScheme,
} from "@mantine/core";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

import SvgIconRaw from "~/components/SvgIconRaw";

import { ThemeModeContext } from "../utils/Contexts";

const ICON_SIZES = { small: 20, medium: 24, large: 35, inherit: "1em" };

const ThemeModeSwitch = ({
  size = "medium",
}: {
  size?: keyof typeof ICON_SIZES;
}) => {
  const { t } = useTranslation("common");
  const themeMode = useContext(ThemeModeContext);
  const { toggleColorScheme } = useMantineColorScheme();
  const colorScheme = useComputedColorScheme("light");
  const iconSize = ICON_SIZES[size];

  return (
    <Tooltip label={t("nav.toggleDarkMode")}>
      <ActionIcon
        variant="subtle"
        color="gray"
        size="lg"
        aria-label={t("nav.toggleDarkMode")}
        onClick={() => {
          toggleColorScheme();
          themeMode.toggleThemeMode();
        }}
      >
        {colorScheme === "dark" ? (
          <SvgIconRaw name="Sun" size={iconSize} />
        ) : (
          <SvgIconRaw name="Moon" size={iconSize} />
        )}
      </ActionIcon>
    </Tooltip>
  );
};

export default ThemeModeSwitch;
